var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content album-list-page" }, [
    _c("div", { staticClass: "page-header-card" }, [
      _vm._m(0),
      _c("div", { staticClass: "header-badges" }, [
        _c("div", { staticClass: "summary-badge" }, [
          _c("span", { staticClass: "summary-badge__label" }, [
            _vm._v("Tổng số album"),
          ]),
          _c("strong", { staticClass: "summary-badge__value" }, [
            _vm._v(_vm._s(_vm.total || 0)),
          ]),
        ]),
        _c("div", { staticClass: "summary-badge" }, [
          _c("span", { staticClass: "summary-badge__label" }, [
            _vm._v("Đang chọn"),
          ]),
          _c("strong", { staticClass: "summary-badge__value" }, [
            _vm._v(_vm._s(_vm.listIdApproveAlbum.length)),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "toolbar-card" }, [
      _c(
        "div",
        { staticClass: "toolbar-left" },
        [
          _c("el-date-picker", {
            staticClass: "toolbar-datepicker",
            attrs: {
              clearable: true,
              "value-format": "yyyy-MM-dd",
              format: "dd-MM-yyyy",
              type: "daterange",
              "unlink-panels": "",
              "range-separator": "→",
              "start-placeholder": "Ngày bắt đầu",
              "end-placeholder": "Ngày kết thúc",
            },
            on: {
              change: function ($event) {
                return _vm.searchByProperties()
              },
            },
            model: {
              value: _vm.dataSearch.dateList,
              callback: function ($$v) {
                _vm.$set(_vm.dataSearch, "dateList", $$v)
              },
              expression: "dataSearch.dateList",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "toolbar-select",
              attrs: { placeholder: "Chọn lớp", clearable: "" },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.idClass,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idClass", $$v)
                },
                expression: "dataSearch.idClass",
              },
            },
            _vm._l(_vm.listClass, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.className, value: item.id },
              })
            }),
            1
          ),
          _vm.getAppTypeUserLogin === "plus"
            ? _c(
                "el-select",
                {
                  staticClass: "toolbar-select",
                  attrs: { placeholder: "Loại album", clearable: "" },
                  on: {
                    change: function ($event) {
                      return _vm.searchHeaderMethod()
                    },
                  },
                  model: {
                    value: _vm.dataSearch.albumType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "albumType", $$v)
                    },
                    expression: "dataSearch.albumType",
                  },
                },
                _vm._l(_vm.albumTypesOption, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm.getAppTypeUserLogin === "plus"
            ? _c(
                "el-select",
                {
                  staticClass: "toolbar-select",
                  attrs: { placeholder: "Trạng thái", clearable: "" },
                  on: {
                    change: function ($event) {
                      return _vm.searchHeaderMethod()
                    },
                  },
                  model: {
                    value: _vm.dataSearch.hideAndShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "hideAndShow", $$v)
                    },
                    expression: "dataSearch.hideAndShow",
                  },
                },
                _vm._l(_vm.statusAlbum, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.checkPermission(["studentQuality_ablum_update"])
        ? _c(
            "div",
            { staticClass: "toolbar-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "cancel-link",
                  attrs: { to: { path: "/student-quality/album/add" } },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-action",
                      attrs: { type: "success", icon: "el-icon-plus" },
                    },
                    [_vm._v("Tạo Album")]
                  ),
                ],
                1
              ),
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleCommandAction },
                },
                [
                  _c(
                    "el-button",
                    { staticClass: "btn-action", attrs: { type: "primary" } },
                    [
                      _vm._v("\n          Tác vụ "),
                      _c("i", { staticClass: "el-icon-caret-bottom" }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { staticClass: "album-dropdown-menu" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "approveAlbum" } },
                        [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" Duyệt Album\n          "),
                        ]
                      ),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "unApproveAlbum" } },
                        [
                          _c("i", { staticClass: "el-icon-close" }),
                          _vm._v(" Hủy duyệt Album\n          "),
                        ]
                      ),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "deleteMultiAlbum" } },
                        [
                          _c("i", { staticClass: "el-icon-delete" }),
                          _vm._v(" Xóa Album\n          "),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm.total > 0
      ? _c("div", { staticClass: "grid-shell" }, [
          _c(
            "div",
            { staticClass: "select-bar" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { indeterminate: _vm.isIndeterminate },
                  on: { change: _vm.handleCheckAllChange },
                  model: {
                    value: _vm.isCheckAll,
                    callback: function ($$v) {
                      _vm.isCheckAll = $$v
                    },
                    expression: "isCheckAll",
                  },
                },
                [_vm._v("\n        Chọn tất cả\n      ")]
              ),
              _vm.listIdApproveAlbum.length > 0
                ? _c("span", { staticClass: "select-bar__count" }, [
                    _vm._v(
                      "\n        Đã chọn " +
                        _vm._s(_vm.listIdApproveAlbum.length) +
                        " album\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "album-grid" },
            _vm._l(_vm.albumResponseList, function (albumResponse) {
              return _c(
                "div",
                {
                  key: albumResponse.id,
                  staticClass: "album-card",
                  class: { "album-card--selected": albumResponse.checkApprove },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "album-card__cover-link",
                      attrs: {
                        to: {
                          path:
                            "/student-quality/album-detail/" + albumResponse.id,
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "album-card__cover" },
                        [
                          albumResponse.albumNew ||
                          albumResponse.urlPictureFirst === null
                            ? _c("TagFlag", { attrs: { title: "Mới" } })
                            : _vm._e(),
                          albumResponse.urlPictureFirst != null
                            ? _c("el-image", {
                                staticClass: "album-card__img",
                                attrs: {
                                  src: albumResponse.urlShowPicture,
                                  fit: "cover",
                                },
                              })
                            : _c("div", { staticClass: "album-card__no-img" }, [
                                _c("i", {
                                  staticClass:
                                    "el-icon-picture-outline album-card__no-img-icon",
                                }),
                                _c("span", [_vm._v("Chưa có ảnh")]),
                              ]),
                          _c(
                            "div",
                            {
                              staticClass: "album-card__status-badge",
                              class: albumResponse.albumView
                                ? "badge--visible"
                                : "badge--hidden",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    albumResponse.albumView
                                      ? "Đang hiện"
                                      : "Đã ẩn"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "album-card__info" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "album-card__name-link",
                          attrs: {
                            to: {
                              path:
                                "/student-quality/album-detail/" +
                                albumResponse.id,
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "album-card__name" }, [
                            _vm._v(
                              _vm._s(_vm.albumResponseAlbumName(albumResponse))
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "album-card__meta" }, [
                        albumResponse.className
                          ? _c(
                              "span",
                              { staticClass: "album-card__meta-item" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-office-building",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(albumResponse.className) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        albumResponse.albumType
                          ? _c(
                              "span",
                              { staticClass: "album-card__meta-item" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-collection-tag",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(albumResponse.albumType) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("span", { staticClass: "album-card__meta-item" }, [
                          _c("i", {
                            staticClass: "el-icon-picture",
                            staticStyle: { color: "#6298d0" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(albumResponse.pictureNumber) +
                              " ảnh\n            "
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "album-card__footer" },
                        [
                          _c("el-checkbox", {
                            key: albumResponse.id,
                            on: {
                              change: (val) =>
                                _vm.checkApproveAlbum(albumResponse.id, val),
                            },
                            model: {
                              value: albumResponse.checkApprove,
                              callback: function ($$v) {
                                _vm.$set(albumResponse, "checkApprove", $$v)
                              },
                              expression: "albumResponse.checkApprove",
                            },
                          }),
                          _c("span", { staticClass: "album-card__date" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDateTime")(
                                  albumResponse.createdDate
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "album-card__actions",
                          class: albumResponse.albumView
                            ? "actions--visible"
                            : "actions--hidden",
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "album-card__action-btn",
                              attrs: {
                                size: "mini",
                                loading: albumResponse.checkDownload,
                                icon: "el-icon-download",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.download1(albumResponse)
                                },
                              },
                            },
                            [_vm._v("Tải về")]
                          ),
                          _vm.checkPermission(["studentQuality_ablum_update"])
                            ? _c(
                                "el-button",
                                {
                                  staticClass:
                                    "album-card__action-btn album-card__action-btn--danger",
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteAlbum(albumResponse.id)
                                    },
                                  },
                                },
                                [_vm._v("Xóa")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ])
      : _c(
          "div",
          { staticClass: "empty-state" },
          [
            _c("i", { staticClass: "el-icon-folder-opened empty-state__icon" }),
            _c("div", { staticClass: "empty-state__title" }, [
              _vm._v("Chưa có album nào"),
            ]),
            _c("div", { staticClass: "empty-state__desc" }, [
              _vm._v("Thay đổi bộ lọc hoặc tạo album mới để bắt đầu."),
            ]),
            _vm.checkPermission(["studentQuality_ablum_update"])
              ? _c(
                  "router-link",
                  {
                    staticClass: "cancel-link",
                    attrs: { to: { path: "/student-quality/album/add" } },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-action",
                        attrs: { type: "success", icon: "el-icon-plus" },
                      },
                      [_vm._v("Tạo Album")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
    _vm.total > 0
      ? _c(
          "div",
          { staticClass: "pagination-wrap" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.pageNumber,
                "page-sizes": _vm.listPageSize,
                "page-size": _vm.maxPageItem,
                layout: _vm.$pageLayoutDefault,
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "update:currentPage": function ($event) {
                  _vm.pageNumber = $event
                },
                "update:current-page": function ($event) {
                  _vm.pageNumber = $event
                },
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h2", { staticClass: "page-title" }, [_vm._v("Quản lý Album")]),
      _c("p", { staticClass: "page-description" }, [
        _vm._v("Tìm kiếm, duyệt và quản lý toàn bộ album ảnh của trường."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }